import React, { useEffect } from "react"
import ReactPlayer from "react-player"
import { GatsbyImage } from "gatsby-plugin-image"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const motionSection = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      when: "beforeChildren",
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}

const eventCalendar = ({ block }) => {
  const { heading, videoUrl } = block

  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  return (
    <motion.section
      className="section module-bark-rules p-6 lg:p-12"
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
    >
      <div className="module-image-text__content flex justify-center items-center mb-8">
        {/* <h2 className="w-fit h2 mb-6 relative after:content-[''] after:bg-orange-400 after:h-2 after:w-full after:absolute after:-bottom-4 after:left-0">
            {block.heading}
          </h2> */}
        <h2 className="w-fit h2 mb-6 relative">
          <motion.div variants={title}>{heading}</motion.div>
          <motion.div
            variants={underline}
            className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
          />
        </h2>
      </div>

      <div className="event-calendar__main">

        <div className="border border-black">

          <div className="border-bottom flex justify-between items-center">
            <h3>Events by location</h3>
            <select name="select" id="">
              <option value="Old fourth ward">Old Fourth Ward</option>
              <option value="Old fourth ward">Alpharetta</option>
              <option value="Old fourth ward">Columnbus</option>\
            </select>
          </div>

          <div className="grid grid-cols-3 gap-8">
            <div className="p-6">
              <p>may 18, 2022</p>
              <p>FREE</p>
              <p>Trivia night</p>
            </div>
            <div className="p-6">
              <p>may 18, 2022</p>
              <p>FREE</p>
              <p>Trivia night</p>
            </div>
            <div className="p-6">
              <p>may 18, 2022</p>
              <p>FREE</p>
              <p>Trivia night</p>
            </div>
            <div className="p-6">
              <p>may 18, 2022</p>
              <p>FREE</p>
              <p>Trivia night</p>
            </div>
            <div className="p-6">
              <p>may 18, 2022</p>
              <p>FREE</p>
              <p>Trivia night</p>
            </div>
            <div className="p-6">
              <p>may 18, 2022</p>
              <p>FREE</p>
              <p>Trivia night</p>
            </div>
            <div className="p-6">
              <p>may 18, 2022</p>
              <p>FREE</p>
              <p>Trivia night</p>
            </div>
            <div className="p-6">
              <p>may 18, 2022</p>
              <p>FREE</p>
              <p>Trivia night</p>
            </div>
            <div className="p-6">
              <p>may 18, 2022</p>
              <p>FREE</p>
              <p>Trivia night</p>
            </div>
            
          </div>

        </div>

      </div>
    </motion.section>
  )
}

export default eventCalendar
